import React from 'react';
export const EmailVerification = React.lazy(() => import('./EmailVerification.jsx'));
